import { motion, MotionValue, useScroll, useTransform } from 'motion/react';

import React, { ReactElement, useRef } from 'react';

import './revealWord.css';



export function Paragraph(
    {paragraph, verticalDirection = 'top', horizontalDirection = 'left', magnitude}:
    {paragraph: string, verticalDirection: 'top' | 'bottom', horizontalDirection: 'left' | 'right', magnitude: number }) {

  const container = useRef(null);
  const { scrollYProgress } = useScroll({
    target: container,
    offset: ["start 1", "start .35"]
  })

  const words = paragraph.split(" ")

  return (
    <div 
      ref={container}         
      className='paragraph'
    >
    {words.map( (word, i) => {
        const start = i / words.length
        const end = start + (1 / words.length)

        return (
        <Word 
          key={i} 
          progress={scrollYProgress} 
          range={[start, end]} 
          verticalDirection={verticalDirection} 
          horizontalDirection={horizontalDirection}
          magnitude={magnitude}
        >
          {word}
        </Word>
      )
      })
    }
    </div>
  )
}



const Word = (
  {children, progress, range, verticalDirection, horizontalDirection, magnitude}:
  {children: string, progress: MotionValue<number>, range: number[], verticalDirection: 'top' | 'bottom', horizontalDirection: 'left' | 'right', magnitude: number}) => {

    const amount = range[1] - range[0]
    const step = amount / children.length
    return (
        <div className='word'>
            <motion.span >
            { children.split("").map((char, i) => {

                const start = range[0] + (i * step);

                const end = range[0] + ((i + 1) * step)

                return <Char
                            char={char} 
                            key={`c_${i}`} 
                            progress={progress} 
                            range={[start, end]} 
                            horizontalDirection={horizontalDirection}
                            verticalDirection={verticalDirection}
                            magnitude={magnitude}
                        /> 

                })
            }
            </motion.span>
        </div>
    )
}

const Char = (
  {char, progress, range, verticalDirection = 'top', horizontalDirection = 'left', magnitude}:
  {char: string, progress: MotionValue<number>, range: number[], verticalDirection: 'top' | 'bottom', horizontalDirection: 'left' | 'right', magnitude: number}) => {

    const opacity = useTransform(progress, range, [0,1])
    const horizontalOutputRange = horizontalDirection === 'left'? [`-${1 * magnitude}vw`, '0vw']: [`${1 * magnitude}vw`, '0vw']
    const verticalOutputRange = verticalDirection === 'top'? [`-${1 * magnitude}vh`, '0vh']: [`${1 * magnitude}vh`, '0vh']
    const y = useTransform(progress, range, verticalOutputRange)
    const x = useTransform(progress, range, horizontalOutputRange)

    return (


        <motion.span style={{opacity: opacity, y: y, x: x, display:'inline-block'}}>{char}</motion.span>


    )

}